const rankingItems = [
  { id: 1, rank: 1, title: '网红偷税被查涉及千万元级别金额', heat: '198万', change: 'up', tag: '重磅' },
  { id: 2, rank: 2, title: '顶流男星深夜密会神秘女子监控流出', heat: '176万', change: 'up', tag: '独家' },
  { id: 3, rank: 3, title: '体育明星婚内出轨品牌方纷纷解约', heat: '156万', change: 'new', tag: '劲爆' },
  { id: 4, rank: 4, title: '综艺节目组内部邮件：淘汰名单内定', heat: '134万', change: 'up', tag: '爆料' },
  { id: 5, rank: 5, title: '女团成员被爆私下霸凌队友录音曝光', heat: '112万', change: 'up', tag: '深扒' },
  { id: 6, rank: 6, title: '娱乐圈阴阳合同再现税务部门介入', heat: '98万', change: 'up', tag: '重磅' },
  { id: 7, rank: 7, title: '某艺人前员工联合爆料合同欺诈内幕', heat: '87万', change: 'new', tag: '独家' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">吃瓜热度榜</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">实时更新911吃瓜事件热度排行，看看今天什么最火</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="divide-y divide-background-200/60">
            {rankingItems.map((item, i) => (
              <div key={item.id} className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/60 transition-colors cursor-pointer ${i < 3 ? 'bg-primary-50/30' : ''}`}>
                <div className="shrink-0 w-8 text-center">
                  {item.rank <= 3 ? (
                    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${
                      item.rank === 1 ? 'bg-primary-500 text-background-50' :
                      item.rank === 2 ? 'bg-primary-400 text-background-50' :
                      'bg-accent-500 text-background-50'
                    }`}>{item.rank}</span>
                  ) : (
                    <span className="text-sm font-bold text-foreground-500">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-800 line-clamp-1">{item.title}</h3>
                </div>

                <div className="shrink-0 flex items-center gap-3">
                  <span className="px-1.5 py-0.5 rounded text-xs font-semibold bg-primary-100 text-primary-700">{item.tag}</span>
                </div>

                <div className="shrink-0 flex items-center gap-2">
                  <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">{item.heat}热度</span>
                  {item.change === 'up' && (
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-arrow-up-line text-accent-600 text-sm"></i>
                    </span>
                  )}
                  {item.change === 'new' && (
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-bold rounded">NEW</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}